import { XIcon } from "@primer/octicons-react";
import { useCallback, useMemo } from "react";
import DataGrid from "../../../components/data-grid";
import { IDataGridColumn } from "../../../components/data-grid/type/IDataGridProps";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import MyModal from "../../../components/ui/modal/MyModal";
import TextWithEllipse from "../../../components/ui/text-with-ellipse/TextWithEllipse";

type DetailModalProps = {
    title?: string,
    onClose: () => void,
    dataSource: any
}

const DetailModal = (props: DetailModalProps) => {

    const onCloseForm = useCallback(() => {
        props.onClose();
    }, [props.onClose]);

    // Generate columns based on dataSource
    const columns: IDataGridColumn[] = useMemo(() => {
        if (props.dataSource && props.dataSource.length > 0) {
            const keys = Object.keys(props.dataSource[0]);
            return keys.map((key) => ({
                dataField: key,
                caption: key.charAt(0).toUpperCase() + key.slice(1),
                cellRender: (data: any) => <TextWithEllipse text={data[key]} lineNumber={1} />
            }));
        }
        return [];
    }, [props.dataSource]);


    return (
        <MyModal
            width={'90%'}
            title={props.title}
            onClose={onCloseForm}
            isOpen={true}
        >
            <div className="pop-up-form">
                <DataGrid
                    dataSource={props.dataSource}
                    columns={columns}
                    height={window.innerHeight - 250}
                    paging={{ enable: true, pageSize: 50, pageSizeItems: [50, 100, 200, 500, 1000] }}
                    searchEnable={true}
                    filterRow={{ enable: true }}
                />
            </div>
            <ModalActions>
                <Button variant="default" onClick={onCloseForm} leadingVisual={XIcon}>Đóng</Button>
            </ModalActions>
        </MyModal>
    );
}

export default DetailModal;
